import { type Option } from '@allesauto/core/searchDropdown';
import { SchemaTypes } from '@allesauto/graphql';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

export type DealerConditionState = {
  selectedDealer: SchemaTypes.Dealer | null;
  selectedDealerSearchOption: Option | null;
};
const initialState: DealerConditionState = {
  selectedDealer: null,
  selectedDealerSearchOption: null,
};

/**
 * Saves the dealer finder selection
 */
const slice = createSlice({
  name: 'tradein/dealer',
  initialState,
  reducers: {
    selectDealer(state, action: PayloadAction<SchemaTypes.Dealer>) {
      state.selectedDealer = action.payload;
    },
    saveDealerSearchOption(
      state,
      action: PayloadAction<{ option: Option | null }>
    ) {
      state.selectedDealerSearchOption = action.payload.option;
    },
    resetDealer() {
      return initialState;
    },
  },
});

export const { selectDealer, saveDealerSearchOption, resetDealer } =
  slice.actions;

export const getTradeInDealerState = (state: RootState): DealerConditionState =>
  state.pages.tradeIn.dealer;

export default slice.reducer;
